import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Divider, Menu, MenuItem } from "@mui/material";

import routes from "../../../constants/routes";
import { requestsTabPath } from "../JoinRequestStatus";

// The red number next to Auctions: requests to participate waiting for a
// decision. A click opens the auctions they are for (straight to the one
// auction's Requests tab when there is only one); admins also get "See all".
const WaitingRequestsBadge = ({ pending, isAdmin }) => {
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState(null);
  const count = pending?.total || 0;
  const auctions = pending?.auctions || [];
  if (count <= 0) return null;

  const open = (event) => {
    // the menu item around it would open the auctions list
    event.stopPropagation();
    if (auctions.length === 1 && !isAdmin) {
      navigate(requestsTabPath(auctions[0].eventId));
      return;
    }
    setAnchor(event.currentTarget);
  };
  const go = (path) => (event) => {
    event.stopPropagation();
    setAnchor(null);
    navigate(path);
  };

  return (
    <>
      <Box
        component="button"
        type="button"
        onClick={open}
        aria-label={`${count} ${count === 1 ? "request" : "requests"} waiting`}
        sx={{
          ml: 0.75,
          px: 0.9,
          py: 0.1,
          border: 0,
          borderRadius: "10px",
          backgroundColor: "#DD391E",
          color: "#FFFFFF",
          fontSize: "11px",
          fontWeight: 700,
          cursor: "pointer",
          lineHeight: 1.6,
        }}
      >
        {count}
      </Box>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={(event) => {
          event?.stopPropagation?.();
          setAnchor(null);
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <MenuItem disabled sx={{ fontWeight: 700, opacity: "1 !important" }}>
          Join requests waiting
        </MenuItem>
        {auctions.map((auction) => (
          <MenuItem
            key={auction.eventId}
            onClick={go(requestsTabPath(auction.eventId))}
            sx={{ gap: 2, justifyContent: "space-between", minWidth: 260 }}
          >
            <span>{auction.auctionTitle}</span>
            <strong>{auction.count}</strong>
          </MenuItem>
        ))}
        {isAdmin && <Divider />}
        {isAdmin && (
          <MenuItem onClick={go(routes.joinRequests)}>See all join requests</MenuItem>
        )}
      </Menu>
    </>
  );
};

export default WaitingRequestsBadge;
